import {Button, Cascader, Form, Input, Select, Space} from "antd";
import React from "react";
import {filterFields, opOptions} from "../../../stores/fixed/BuildInVocs";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";

export const makeSelectOption = (item) => <Select.Option value={item.value}>{item.title}</Select.Option>
export const PatientQuerySimpleEditor = ({name, width}) =>
    <Form.List name={name || "patients"} style={{width: width || '100%'}}>
        {(fields, {add, remove}) => (
            <>
                {fields.map(({key, name, fieldKey, ...restFields}) => (
                    <Space key={key} align="baseline">
                                <Form.Item
                                    {...restFields}
                                    label="Поле"
                                    name={[name, 'fld']}
                                    fieldKey={[fieldKey, 'fld']}
                                    rules={[{required: true, message: 'Не указано поле'}]}

                                >
                                    <Cascader options={filterFields}></Cascader>
                                </Form.Item>
                        <Form.Item
                            {...restFields}
                            label="Оператор"
                            name={[name, 'op']}
                            fieldKey={[fieldKey, 'op']}
                            style={{width: 250}}
                            rules={[{required: true, message: 'Не указана операция'}]}
                        >
                            <Select>
                                {opOptions.map(makeSelectOption)}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            {...restFields}
                            label="Значение"
                            name={[name, 'val']}
                            fieldKey={[fieldKey, 'val']}
                            rules={[{required: true, message: 'Не указано значение'}]}
                        >
                            <Input/>
                        </Form.Item>

                        <MinusCircleOutlined onClick={() => remove(name)}/>
                    </Space>
                ))}
                <Form.Item>
                    <Button type="dashed"  onClick={() => add()} block icon={<PlusOutlined/>}>
                        Добавить правило
                    </Button>
                </Form.Item>
            </>
        )}
    </Form.List>